import * as Sentry from '@sentry/react'

// const SENTRY_DSN = window.settings.SENTRY_DSN
const isDevelopment = location.hostname.includes('dev.cusman.ai')
const isProduction = !location.hostname.includes('localhost') && !isDevelopment

const devDNS =
  'https://a7d2d72035588698b092014ee0b984c5@o4505810207768576.ingest.us.sentry.io/4505822395891712'
const prodDNC =
  'https://124867fb4457f3c76acd8265e5eead0c@o4505810207768576.ingest.us.sentry.io/4506807386112000'

if (isProduction) {
  console.debug('Sentry init production')
  Sentry.init({
    dsn: prodDNC,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
  })
}

if (isDevelopment) {
  console.debug('Sentry init development')
  Sentry.init({
    dsn: devDNS,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
  })
}

export default Sentry
